import { Injectable, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NavigationHistoryService {
  private readonly router = inject(Router);
  private readonly history: string[] = [];

  constructor() {
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        const url = event.urlAfterRedirects;
        if (this.history.at(-1) !== url) {
          this.history.push(url);
        }
      });
  }

  getReturnUrl(): string | null {
    if (this.history.length < 2) {
      return null;
    }

    const currentUrl = this.normalizeUrl(this.router.url);

    for (let i = this.history.length - 2; i >= 0; i--) {
      const url = this.history[i];
      const normalized = this.normalizeUrl(url);

      if (normalized === currentUrl || this.isLoanDetailsUrl(normalized) || this.isCustomerDetailsUrl(normalized) || this.isAuthUrl(normalized)) {
        continue;
      }

      return url;
    }

    return null;
  }

  clear(): void {
    this.history.length = 0;
  }

  resetAfterAuthentication(url: string): void {
    this.history.length = 0;
    this.history.push(url);
  }

  private normalizeUrl(url: string): string {
    return url.split('?')[0].split('#')[0];
  }

  private isLoanDetailsUrl(url: string): boolean {
    return /\/collect\/loans\/[^/]+/.test(url);
  }

  private isCustomerDetailsUrl(url: string): boolean {
    return /\/collect\/customers\/[^/]+/.test(url);
  }

  private isAuthUrl(url: string): boolean {
    return (
      url === '/login' ||
      url === '/forgot-password' ||
      url.startsWith('/reset-password') ||
      url.startsWith('/password/')
    );
  }
}
